import React, {PropTypes, Component} from 'react';
import ToggleButton from '../../../common/components/c_ToggleButton';

const yesNo = [{value: true, primaryText: 'Yes'}, {value: false, primaryText: 'No'}];

export default function LicenseLapsed(props) {

  const handleChange = (event, value) => {
    if (props.onChange) {
      return props.onChange(event, value);
    }
  };

  return (
    <ToggleButton
      data-id='Willing To Reinstate'
      floatingLabelText={props.label}
      menuItems={yesNo}
      value={props.value}
      onChange={handleChange}
    />
  );
}

LicenseLapsed.propTypes = {
  label    : PropTypes.string,
  value    : PropTypes.bool,
  onChange : PropTypes.func
};



// WEBPACK FOOTER //
// ./shared/react/applicant/LicensesForm/LicenseLapsed.js